import { StringBase } from '../StringBase';

export class City extends StringBase {}
